import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eb72333"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "title"]

import ROUTER_TYPE from '@/router/routeType'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TheHeaderLogo',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _unref(ROUTER_TYPE).TOP.path,
    class: "navbar-brand mxa-header-logo",
    title: _ctx.$t('header.logo.title'),
    "data-test": "logo"
  }, null, 8, _hoisted_1))
}
}

})